import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformAdminProfileHistory } from './admin-profile-history.transformers';
import type { AdminProfileHistoryCollection } from './admin-profile-history.types';

export function adminProfileHistoryReducer(
  state: CollectionStateSlice<AdminProfileHistoryCollection> = {},
  action: CollectionActions<AdminProfileHistoryCollection>,
): CollectionStateSlice<AdminProfileHistoryCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'adminProfileHistory') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<AdminProfileHistoryCollection>(
          state,
          transformIntoDocuments(
            result.data || [],
            transformAdminProfileHistory,
          ),
          order,
          ref,
          result.totalCount || 0,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
